import { z } from 'zod'

/**
 * Clipbook staff's record of which client dashboards have been vetted in Headline. Deliberately not
 * on `subaccountSchema`, which every customer who can open an account is sent: this is a separate
 * response from a staff-only route, so a customer's browser never holds it, hidden or otherwise.
 */
export const dashboardVettingEntrySchema = z.object({
  subaccountId: z.uuid(),
  name: z.string(),
  /** The account's own sub-account, and for a client migrated from legacy usually its only one. */
  isPrimary: z.boolean(),
  /** When it was vetted; null means it has not been. */
  vettedAt: z.string().nullable(),
  /** The legacy subscriptions this dashboard stands for: opaque Firestore ids. */
  legacySubscriptionIds: z.array(z.string()),
})
export type DashboardVettingEntry = z.infer<typeof dashboardVettingEntrySchema>

export const listDashboardVettingResponseSchema = z.object({
  subaccounts: z.array(dashboardVettingEntrySchema),
})
export type ListDashboardVettingResponse = z.infer<typeof listDashboardVettingResponseSchema>

export const setDashboardVettedSchema = z.object({ vetted: z.boolean() })

export const setLegacySubscriptionsSchema = z.object({
  ids: z.array(z.string().trim().min(1).max(200)).max(100),
})
